/* YAP: turn plain phone numbers and email addresses in page, policy and article bodies into tap-to-call / mailto links.
   Owner request 2026-09-25 ("hyperlink all contact information"). Text already inside a link, button or form field is left alone. */
(function () {
  if (window.__yapContactLinks) return;
  window.__yapContactLinks = true;
  var RE = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|((?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]\d{4})/g;
  var SKIP = /^(A|BUTTON|SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|LABEL|CODE|PRE|NOSCRIPT)$/;
  function skip(n) { for (; n && n.nodeType === 1; n = n.parentNode) { if (SKIP.test(n.nodeName) || n.isContentEditable) return true; } return false; }
  function link(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = w.nextNode())) { RE.lastIndex = 0; if (RE.test(n.nodeValue) && !skip(n.parentNode)) nodes.push(n); }
    nodes.forEach(function (t) {
      var s = t.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      RE.lastIndex = 0;
      while ((m = RE.exec(s))) {
        if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
        var a = document.createElement('a');
        if (m[1]) { a.href = 'mailto:' + m[1]; }
        else { var d = m[2].replace(/\D/g, ''); if (d.length === 10) d = '1' + d; a.href = 'tel:+' + d; }
        a.textContent = m[0];
        a.className = 'yap-contact-link';
        frag.appendChild(a);
        last = m.index + m[0].length;
      }
      if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
      t.parentNode.replaceChild(frag, t);
    });
  }
  function run() {
    var roots = document.querySelectorAll('.shopify-policy__container, main .rte, main .page-content, main article, #MainContent .rte');
    var seen = [];
    Array.prototype.forEach.call(roots, function (r) { if (!seen.some(function (s) { return s.contains(r); })) { seen.push(r); link(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
